<template>
  <div class="col-lg-4 col-md-6 mb-4">
    <div class="card h-100">
      <div class="card-body d-flex align-items-center">
        <div class="flex-grow-1">{{ item.label }}</div>
        <router-link
          class="btn btn-sm btn-primary ml-2 float-right"
          :to="{name: 'QuestionShowByPack', params: { packId: item.id }}"
        >{{ $t('packs.list.play') }}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["item"]
};
</script>



// WEBPACK FOOTER //
// src/components/pack/Card.vue